export default __webpack_public_path__ + "static/media/architecture-3.392c1575.webp";